import React, { useState } from "react";
import { Button, Modal } from "antd";
import { svg } from "../Assets/svg";
import { getFullAwsUrl } from "../helpers/utils";
import axiosInstance from "../helpers/axios";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const DownloadMailerAppModal: React.FC<Props> = ({ open, onClose }) => {
  const [downloadingPlatform, setDownloadingPlatform] = useState<string | null>(null);

  const userAgent = window.navigator.userAgent.toLowerCase();
  const isWindows = userAgent.includes("win");
  const isMac = userAgent.includes("mac");
  const isLinux = userAgent.includes("linux");
  const showAll = !isWindows && !isMac && !isLinux;

  const handleDownload = async (platform: "windows" | "mac" | "linux", fallbackFileKey: string) => {
    setDownloadingPlatform(platform);
    let downloadUrl = "";
    const targetVersion = process.env.REACT_APP_DESKTOP_APP_VERSION || "1.0.1";

    try {
      const res = await axiosInstance.get(`/file-upload/app-download-url?platform=${platform}&version=${targetVersion}`);
      if (res?.data?.data?.url) {
        downloadUrl = res.data.data.url;
      }
    } catch (err) {
      console.warn("Could not fetch presigned URL, using direct AWS URL fallback:", err);
    }

    if (!downloadUrl) {
      downloadUrl = getFullAwsUrl(fallbackFileKey);
    }

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setDownloadingPlatform(null);
    onClose();
  };

  return (
    <Modal
      open={open}
      centered
      width={"45rem"}
      footer={null}
      onCancel={onClose}
      closeIcon={svg?.closeIcon}
      title={<div className="text-center fs-4 fw-bolder lh-m">SM-CRM Mailer Service Not Running</div>}
      className="custom-modal"
    >
      <div className="d-flex flex-column gap-2 align-items-center mb-4">
        <p className="fs-6 text-center">
          Please ensure the SM-CRM Mailer Service is running on your computer and that you are logged in properly. If you haven't installed it yet, please download it below.
        </p>
      </div>
      <div className="row gx-sm-4 gx-2 gy-3 justify-content-center">
        {(isWindows || showAll) && (
          <div className="col-12 col-sm-auto">
            <Button
              loading={downloadingPlatform === "windows"}
              onClick={() => handleDownload("windows", "mail-apps/SM-CRM Mail Gateway Setup 1.0.0.exe")}
              className="btn btn-lg btn-primary w-100 h-auto px-sm-4 text-uppercase"
            >
              Download For Windows
            </Button>
          </div>
        )}
        {(isMac || showAll) && (
          <div className="col-12 col-sm-auto">
            <Button
              loading={downloadingPlatform === "mac"}
              onClick={() => handleDownload("mac", "mail-apps/SM-CRM Mail Gateway-1.0.0-arm64.dmg")}
              className="btn btn-lg btn-primary w-100 h-auto px-sm-4 text-uppercase"
            >
              Download For Mac
            </Button>
          </div>
        )}
        {(isLinux || showAll) && (
          <div className="col-12 col-sm-auto">
            <Button
              loading={downloadingPlatform === "linux"}
              onClick={() => handleDownload("linux", "mail-apps/SM-CRM Mail Gateway-1.0.0.AppImage")}
              className="btn btn-lg btn-primary w-100 h-auto px-sm-4 text-uppercase"
            >
              Download For Linux
            </Button>
          </div>
        )}
        <div className="col-12 mt-3 text-center">
          <Button
            onClick={onClose}
            className="btn btn-lg btn-outline-secondary w-auto h-auto px-sm-5"
          >
            CLOSE
          </Button>
        </div>
      </div>
    </Modal>
  );
};
